# Helper functions for making API calls - basically a wrapper around fetch, with some light error handling.

export default
    get: (url) ->
        return fetch url
        .then (resp) -> resp.json()
        .then (json) ->
            return json
    post: (url, data) ->
        return @_post(url, data, 'POST')
    patch: (url, data) ->
        return @_post(url, data, 'PATCH')
    delete: (url) ->
        return fetch url,
            method: 'DELETE'
        .then (resp) -> resp.json()
        .then (json) ->
            return json
    _post: (url, data, method) ->
        return fetch url,
            method: method
            body: JSON.stringify data
            headers:
                'Content-Type': 'application/json'
        .then (resp) -> resp.json()
        .then (json) ->
            return json
